import poster from "../assets/images/worship-legacy-concert-2026.png";

export const campaign = {
  slug: "worship-legacy-concert-season-7",
  title: "Worship Legacy Concert",
  season: "Season 7",
  year: "2026",
  organiser: "Gisubizo Ministry",
  poweredBy: "Ijambo Events",
  poster,
  venue: "Camp Kigali",
  city: "Kigali",
  contactPhone: "+250 788 880 901",
  ticketTypes: ["SILVER", "PREMIERE", "GOLD", "PLATINUM"],
  artists: ["Gisubizo Ministry"],
  stops: [
    {
      id: "camp-kigali",
      city: "Camp Kigali",
      slug: "worship-legacy-concert-season-7",
      date: "13 September 2026",
      shortDate: "13 Sept",
      isoDate: "2026-09-13",
    },
  ],
  fallbackTickets: [
    { type: "SILVER", price: 10000, preSellPrice: 5000 },
    { type: "PREMIERE", price: 15000, preSellPrice: 10000 },
    { type: "GOLD", price: 25000, preSellPrice: 20000 },
    { type: "PLATINUM", price: 50000 },
  ],
};

export function isCampaignEvent(title?: string, slug?: string) {
  const normalizedTitle = title?.toLowerCase() ?? "";
  const normalizedSlug = slug?.toLowerCase() ?? "";

  return (
    campaign.stops.some((stop) => stop.slug === normalizedSlug) ||
    normalizedTitle.includes("worship legacy")
  );
}

export function getCampaignStopBySlug(slug?: string) {
  return campaign.stops.find((stop) => stop.slug === slug);
}
